import { useCart } from "../../context/CartContext";

// Choices already in the cart for this item, newest first, each removable.
export default function SelectedItems({ item }) {
  const { cart, removeSelection } = useCart();
  const line = cart[item.id];
  if (!line?.items) return null;

  const stamps = line.selectionAddedAt || {};
  const rows = Object.entries(line.items).sort(
    ([a], [b]) => (stamps[b] || 0) - (stamps[a] || 0) || a.localeCompare(b),
  );

  return (
    <section className="v154SelectedItems" aria-label="Selected items">
      <div className="v154SelectedHead">
        <span>Selected item</span>
        <span>Quantity</span>
        <span>Remove</span>
      </div>
      <div className="v154SelectedRows">
        {rows.map(([name, qty]) => (
          <div className="v154SelectedRow" key={name}>
            <span>{name}</span>
            <span className="v154Qty">{qty}</span>
            <button type="button" className="v154Remove" onClick={() => removeSelection(item.id, name)}>
              Remove
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
